import { forwardRef, type ButtonHTMLAttributes } from "react";

import { cn } from "./lib/cn.js";

const variants = {
  primary: "bg-brand text-brand-fg hover:bg-brand-deep focus-visible:ring-brand",
  secondary: "bg-surface text-fg border border-border hover:bg-surface-muted",
  danger: "bg-danger-solid text-danger-solid-fg hover:bg-danger-fg focus-visible:ring-danger-solid",
  ghost: "text-fg-muted hover:bg-border-muted hover:text-fg",
} as const;

const sizes = {
  sm: "px-3 py-1.5 text-xs",
  md: "px-4 py-2 text-sm",
  lg: "px-6 py-3 text-base",
} as const;

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: keyof typeof variants;
  size?: keyof typeof sizes;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = "primary", size = "md", disabled, ...props }, ref) => (
    <button
      ref={ref}
      className={cn(
        "inline-flex items-center justify-center rounded-soft-md font-medium transition-colors",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2",
        "disabled:pointer-events-none disabled:opacity-50",
        variants[variant],
        sizes[size],
        className,
      )}
      disabled={disabled}
      {...props}
    />
  ),
);
Button.displayName = "Button";
